/**
 * useDebouncedValue — the value, once it has stopped changing for `delayMs`.
 *
 * For a search box whose text becomes a server predicate (USR-F1-T2: the
 * Invitations tab sends `q` to the API): typing updates the input at once and
 * the request is issued only after the pause, not once per keystroke.
 */

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
